module.exports = __webpack_public_path__ + "media/images/number_3_green-0df0f4fd00bff6adab8c49a08fa0cbc7.png";